/**
 * Licensed Materials - Property of IBM
 * (c) Copyright IBM Corporation 2026. All Rights Reserved.
 *
 * Note to U.S. Government Users Restricted Rights:
 * Use, duplication or disclosure restricted by GSA ADP Schedule
 * Contract with IBM Corp.
 */
'use strict';

var config = require("../shared/config");

/*
 * TODO: Remove defaultProps error suppression once external packages are updated
 * to remove defaultProps from the following components (last updated for CPC v6.1.1, react-markdown v6.0.3):
 * - CatalogTile (@console/cloud-pal-community)
 * - SectionHeading (@console/cloud-pal-community)
 * - TagArea (@console/cloud-pal-community)
 * - TagModal (@console/cloud-pal-community)
 * - ResourceLevelNavSkeleton (@console/cloud-pal-community)
 * - ResourceTagList (@console/cloud-pal-community)
 * - ResourceTagModal (@console/cloud-pal-community)
 * - ReactMarkdown (react-markdown)
 *
 * TODO: Remove invalid DOM prop error suppression once external packages are updated
 * to remove invalid DOM props from the following components (last updated for CPC v6.1.1, otc-components-react v6.0.11):
 * - tooltipPosition in ResourceTagList (@console/cloud-pal-community)
 * - tagAreaTooltipDirection in ResourceTagModal (@console/cloud-pal-community)
 * - hasForm in SecretInput (@ace/otc-components-react)
 *
 * Suppress React warnings from external library components.
 * In dev/local (ENV_ID=ibm:ys1:us-south), these errors are downgraded to warnings instead of being suppressed.
 * IMPORTANT: This must be set up BEFORE React is imported to catch warnings during React initialization.
 */

function setupConsoleSuppression() {
  if (typeof console !== 'undefined' && console.error) {
    var originalError = console.error;
    var isDevEnv = config.ENV_ID === 'ibm:ys1:us-south';
    console.error = function () {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      // convert all arguments to strings for easier matching
      var errorMessage = args.map(function (arg) {
        return String(arg);
      }).join(' ');

      // suppress React custom attribute warnings for specific props
      var isInvalidDomPropWarning = errorMessage.includes('If you intentionally want it to appear in the DOM as a custom attribute, spell it as lowercase');
      if (isInvalidDomPropWarning) {
        // in local environment, downgrade to warning instead of suppressing
        if (isDevEnv && console.warn) {
          var _console;
          (_console = console).warn.apply(_console, args);
        }
        return;
      }
      var isDefaultPropsWarning = errorMessage.includes('Support for defaultProps will be removed from function components in a future major release');
      if (isDefaultPropsWarning) {
        // in local environment, downgrade to warning instead of suppressing
        if (isDevEnv && console.warn) {
          var _console2;
          (_console2 = console).warn.apply(_console2, args);
        }
        return;
      }

      // pass through all other errors
      originalError.apply(console, args);
    };
  }
}

// Execute immediately when module is loaded
setupConsoleSuppression();